import React, { useMemo } from 'react';
import { TimeBlockGroup } from '../../entities/time-block-group';
import { ITimeBlockListing } from '../../../../entities-generated/models/time-block/time-block-listing';
import { formatString } from '../../../../framework/utils';
import { TimeBlockListItem } from '../time-listing';

interface ITimeBlockGroupListingProps {
  group: TimeBlockGroup;
  onToggleSelection: (block: ITimeBlockListing) => void;
}

export const TimeBlockGroupListing: React.FunctionComponent<ITimeBlockGroupListingProps> = (props) => {
  const { group } = props;
  const heading = useMemo(() => {
    return formatString('{d:d-wwwMMMMdyyyy}', { d: group.date }).formattedString;
  }, [group]);

  return (
    <div>
      <h2>{heading}</h2>
      <div>
        {group.timeBlocks.map(block =>
        <TimeBlockListItem
          key={block.id}
          block={block}
          onToggleSelection={props.onToggleSelection}
        />)}
      </div>
    </div>
  );
};
